import { render, staticRenderFns } from "./FocusGroupList.vue?vue&type=template&id=1197485c"
import script from "./FocusGroupList.vue?vue&type=script&lang=js"
export * from "./FocusGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports